import React from "react";
import "../css/solution.scss";

const productLogos = {
  "Tomko Mobile App": "/images/tomko-app-logo.png",
  "Tomko LMS": "/images/tomko-lms-logo.png",
  "Tomko Books App": "/images/tomko-books-logo.png",
  "Tomko Glubes": "/images/tomko-glubes-logo.png",
};

const TOMKO_LMS_NAME = "Tomko LMS";
const TOMKO_LMS_URL = "https://learning.tomko.mn";
const TOMKO_BOOKS_NAME = "Tomko Books App";
const TOMKO_BOOKS_URL = "https://tomkobooks.com";
const TOMKO_GLUBES_NAME = "Tomko Glubes";
const TOMKO_GLUBES_URL = "https://glubes.tomko.mn";

const renderTextWithLmsLink = (text) => {
  if (!text || !text.includes(TOMKO_LMS_NAME)) {
    return text;
  }

  return text.split(TOMKO_LMS_NAME).map((part, index, parts) => (
    <React.Fragment key={`${part}-${index}`}>
      {part}
      {index < parts.length - 1 && (
        <a
          className="solution-inline-link"
          href={TOMKO_LMS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {TOMKO_LMS_NAME}
        </a>
      )}
    </React.Fragment>
  ));
};

export default function Solution({ data }) {
  const { title, solutions, productsTitle, products = [] } = data;
  return (
    <div className="solution-page">
      <div className="solution-container">
        {products.length > 0 && (
          <section className="products-section">
            <h2>{productsTitle}</h2>
            <div className="product-items">
              {products.map((item, index) => {
                const productLogo = productLogos[item.name] || "/images/tomko-app-logo.png";
                const isTomkoLms = item.name === TOMKO_LMS_NAME;
                const isTomkoBooks = item.name === TOMKO_BOOKS_NAME;
                const isTomkoGlubes = item.name === TOMKO_GLUBES_NAME;
                const isCardLink = isTomkoLms || isTomkoBooks || isTomkoGlubes;

                const inner = (
                  <>
                    <div className="product-icon">
                      <img src={productLogo} alt={`${item.name} logo`} />
                    </div>
                    <div className="product-item-content">
                      <h3>{item.name}</h3>
                      <p>
                        {isCardLink
                          ? item.text
                          : renderTextWithLmsLink(item.text)}
                      </p>
                    </div>
                  </>
                );

                if (isTomkoLms) {
                  return (
                    <a
                      key={index}
                      href={TOMKO_LMS_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="product-item product-item--link"
                    >
                      {inner}
                    </a>
                  );
                }

                if (isTomkoBooks) {
                  return (
                    <a
                      key={index}
                      href={TOMKO_BOOKS_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="product-item product-item--link"
                    >
                      {inner}
                    </a>
                  );
                }

                if (isTomkoGlubes) {
                  return (
                    <a
                      key={index}
                      href={TOMKO_GLUBES_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="product-item product-item--link"
                    >
                      {inner}
                    </a>
                  );
                }

                return (
                  <div key={index} className="product-item">
                    {inner}
                  </div>
                );
              })}
            </div>
          </section>
        )}

        <h2>{title}</h2>
        <div className="solution-items">
          {solutions.map((item, index) => (
            <div key={index} className="solution-item">
              <img src={item.image} alt={item.title} />
              <div className="solution-item-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
